import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ForgotPasswordModal from './ForgotPasswordModal';
import AuthInput from './AuthInput';
import AuthPasswordInput from './AuthPasswordInput';
import Loading from './Loading';
import { useMobile } from '../../contexts/MobileContext';
import { useMessage } from '../../contexts/MessageContext';

import Image from '../../assets/images/login-image.png';

const LoginPage = () => {
  const { isMobile } = useMobile();
  const navigate = useNavigate();
  const showMessage = useMessage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPasswordModalVisible, setForgotPasswordModalVisible] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token !== null) {
      fetch(process.env.REACT_APP_SERVER_URL + '/api/validate-token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
        body: JSON.stringify({})
      })
        .then(response => response.json())
        .then(data => {
          if (data.message === 'invalid token!') {
            console.log('unauthorized access')
            localStorage.removeItem('token');
            return;
          }
          localStorage.setItem('token', token);
          navigate('/dashboard');
        })
        .catch(error => console.error('Error:', error));
    }
    else {
      let token = localStorage.getItem('token');

      if (token) {
        setLoading(true);
        navigate('/dashboard');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = () => {
    setLoading(true);

    fetch(process.env.REACT_APP_SERVER_URL + '/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: email.trim(),
                             password: password.trim(),
                             timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
                           })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          localStorage.setItem('token', data.token);
          navigate('/dashboard');
        } else {
          showMessage('Login failed.');
          setEmail('');
          setPassword('');
          setLoading(false);
        }
      })
      .catch(error => console.error('Error:', error));
  };

  return (
    <div className={`login${isMobile ? ' single' : ''}`}>
      {forgotPasswordModalVisible && (
        <ForgotPasswordModal setVisible={setForgotPasswordModalVisible} />
      )}

      {loading && <Loading text="Loading data..." />}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}>

        <h1>Log In</h1>
        <AuthInput label="Email"
               onChange={(e) => setEmail(e.target.value)}
               value={email}
               type='email'
               placeholder='Enter your email'/>
        <div>
          <AuthPasswordInput label="Password"
                         onChange={(e) => setPassword(e.target.value)}
                         value={password}
                         placeholder='Enter your password'/>
          <button
             type="button"
             className="custom-link2"
             onClick={() => setForgotPasswordModalVisible(true)}>
            Forgot password?
          </button>
        </div>

        <button className="button primary auth-button">Log In</button>

        <p>
          Don't have an account?
          <Link className='custom-link auth-link' to='/signup'>Sign Up</Link>
        </p>

      </form>

      {!isMobile && (
        <img src={Image}
             style={{width: '100%',
                     height: '100%',
                     objectFit: 'cover',
                     borderRadius: 'var(--border-radius)',
                    }}
             alt=""/>
      )}

    </div>
  );
}

export default LoginPage;
